import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IListKey, IListViewState, ViewKey, ViewStateMap } from '@platform/core/types';
import { applyListPatch } from '@platform/core/lib/listState';

export const defaultListViewState = (view: ViewKey = 'table'): IListViewState => ({
  view, quickFilter: 'all', columnFilter: '', search: '', sort: '', page: 1, pageSize: 15, tagFilter: [], savedViewId: null, stage: null,
});

export const listKeyOf = (k: IListKey): string => `${k.workspaceId}|${k.recordType}|${k.menuItem}`;

/** Персистентний стан списків модулів без пакета (ключ = воркспейс|тип|пункт); для модулів із пакетом власник стану списків — зріз `module/<ключ>`. */
export const viewStateSlice = createSlice({
  name: 'viewState',
  initialState: {} as ViewStateMap,
  reducers: {
    listStateChanged(state, action: PayloadAction<{ key: IListKey; patch: Partial<IListViewState>; defaultView?: ViewKey }>) {
      const id = listKeyOf(action.payload.key);
      state[id] = applyListPatch(state[id] ?? defaultListViewState(action.payload.defaultView), action.payload.patch);
    },
    listStateReset(state, action: PayloadAction<IListKey>) { delete state[listKeyOf(action.payload)]; },
    viewStateHydrated(_state, action: PayloadAction<ViewStateMap>) { return action.payload; },
  },
});

export const { listStateChanged, listStateReset, viewStateHydrated } = viewStateSlice.actions;
